"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungValidator = exports.LeitungValidatorKeys = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
// prettier-ignore
class LeitungValidatorKeys {
}
exports.LeitungValidatorKeys = LeitungValidatorKeys;
LeitungValidatorKeys.ueberstandFestpunktGreaterLaenge = 'LeitungUeberstandFestpunkt: ' + 'laenge: ' + echain_shared_validation_1.ValidatorKeys.smaller;
LeitungValidatorKeys.ueberstandFestpunktTooSmall = 'LeitungUeberstandFestpunkt: ' + 'zero: ' + echain_shared_validation_1.ValidatorKeys.bigger;
LeitungValidatorKeys.ueberstandMitnehmerGreaterLaenge = 'LeitungUeberstandMitnehmer: ' + 'laenge: ' + echain_shared_validation_1.ValidatorKeys.smaller;
LeitungValidatorKeys.ueberstandMitnehmerTooSmall = 'LeitungUeberstandMitnehmer: ' + 'zero: ' + echain_shared_validation_1.ValidatorKeys.bigger;
LeitungValidatorKeys.readycableSteckerFpEqualsMn = 'LeitungReadycableSteckerFp: ' + 'equalsMn';
LeitungValidatorKeys.readycableSteckerMnEqualsMn = 'LeitungReadycableSteckerMn: ' + 'equalsMn';
/**
 * The `LeitungValidator` performs validations on the `Kette`.
 */
class LeitungValidator {
    /**
     * Validates if ueberstandFestpunkt of `Leitung` is in range (0 > ueberstandFestpunkt >
     * leitungslaenge).
     */
    static ueberstandFestpunktInRange(ueberstandFestpunkt, leitung, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (ueberstandFestpunkt) {
            v.add(echain_shared_validation_1.Validator.quantityBigger(ueberstandFestpunkt, 'mm', LeitungValidator.ueberstandFestpunktBiggerM, keyPrefix + LeitungValidatorKeys.ueberstandFestpunktTooSmall));
            if (leitung.leitungslaenge && leitung.leitungslaenge.mm) {
                v.add(echain_shared_validation_1.Validator.quantitySmaller(ueberstandFestpunkt, 'mm', leitung.leitungslaenge.mm, keyPrefix + LeitungValidatorKeys.ueberstandFestpunktGreaterLaenge));
            }
        }
        return v;
    }
    /**
     * Validates if ueberstandMitnehmer of `Leitung` is in range (0 > ueberstandMitnehmer >
     * leitungslaenge).
     */
    static ueberstandMitnehmerInRange(ueberstandMitnehmer, leitung, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (ueberstandMitnehmer) {
            v.add(echain_shared_validation_1.Validator.quantityBigger(ueberstandMitnehmer, 'mm', LeitungValidator.ueberstandMitnehmerBiggerM, keyPrefix + LeitungValidatorKeys.ueberstandMitnehmerTooSmall));
            if (leitung.leitungslaenge && leitung.leitungslaenge.mm) {
                v.add(echain_shared_validation_1.Validator.quantitySmaller(ueberstandMitnehmer, 'mm', leitung.leitungslaenge.mm, keyPrefix + LeitungValidatorKeys.ueberstandMitnehmerGreaterLaenge));
            }
        }
        return v;
    }
    static readycableSteckerFp(steckerFp, leitung, keyPrefix = '') {
        if (!leitung.isReadycable()) {
            return echain_shared_validation_1.Validation.empty();
        }
        if (steckerFp && steckerFp === leitung.toModel().SteckerMn) {
            return echain_shared_validation_1.Validation.create(false, keyPrefix + LeitungValidatorKeys.readycableSteckerFpEqualsMn);
        }
        return echain_shared_validation_1.Validation.success();
    }
    static readycableSteckerMn(steckerMn, leitung, keyPrefix = '') {
        if (!leitung.isReadycable()) {
            return echain_shared_validation_1.Validation.empty();
        }
        if (steckerMn && steckerMn === leitung.toModel().SteckerFp) {
            return echain_shared_validation_1.Validation.create(false, keyPrefix + LeitungValidatorKeys.readycableSteckerMnEqualsMn);
        }
        return echain_shared_validation_1.Validation.success();
    }
}
exports.LeitungValidator = LeitungValidator;
LeitungValidator.ueberstandFestpunktBiggerM = 0;
LeitungValidator.ueberstandMitnehmerBiggerM = 0;
//# sourceMappingURL=LeitungValidator.js.map